import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { InitMonitoringTool } from './assets/js/monitoring-tool';
import { InitDevTools } from './assets/js/eruda-devtools';

InitMonitoringTool();
InitDevTools();

if (environment.production) {
	enableProdMode();
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
